<template>
  <b-card
    class="mb-0"
  >
    <div class="mb-2">
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <h4 class="card-title mb-0 pt-50">
            Interviews</h4>
        </b-col>
        <b-col
          cols="12"
          md="8 ml-auto"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-input-group>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search"
                @keyup.enter="updateSearchQuery"
              />
              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  @click="updateSearchQuery"
                >
                  <feather-icon
                    icon="SearchIcon"
                    size="14"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button
              variant="primary"
              class="ml-2 min-w-190"
              :to="{ name: 'human-resources-interviews-new'}"
            >
              Schedule Interview
            </b-button>
          </div>
        </b-col>
      </b-row>

    </div>

    <vue-good-table
      :columns="columns"
      :rows="interviewsResponse.interviews"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'fullName'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.fullName }}</span>
        </span>

        <span
          v-if="props.column.field === 'consent'"
          class="con"
        >
          <b-badge
            v-if="props.row.consent_available && props.row.consent_completed"
            variant="light-success"
          >
            Consent Accepted
          </b-badge>
          <b-badge
            v-if="props.row.consent_available && !props.row.consent_completed"
            :to="{ name: 'interview-consent', params: { token: props.row.token } }"
            variant="primary"
          >
            Accept Consent
          </b-badge>
          <!-- <b-badge variant="light-primary">
            Accept Consent
          </b-badge>
          <b-badge variant="light-primary"></b-badge> -->
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'selectStatus'">
          <v-select
            v-model="props.row.status"
            :options="status"
            :reduce="item => item.id"
            :clearable="false"
            placeholder="Select"
            @input="onStatusChanged(props.row)"
          />
        </span>

        <!-- Column: Action -->
        <span
          v-else-if="props.column.field === 'action'"
          class="btn-action"
        >
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item :to="{ name: 'human-resources-interviews-edit', params: { id: props.row.id } }">
                <feather-icon icon="Edit2Icon" />
                <span class="ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="confirmDeleteRecord(props.row)">
                <feather-icon icon="TrashIcon" />
                <span class="ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
            <b-link
              id="view"
              :to="{ name: 'human-resources-interviews-view', params: { id: props.row.id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
      >
        <div class="d-flex justify-content-end flex-wrap">
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="interviewsResponse.count"
              first-number
              last-number
              align="right"
              :per-page="1"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BAvatar, BBadge, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Interviews from '@/js/interviews'
import LIST from '@/js/lists'

export default {
  name: 'InterviewsList',
  components: {
    BCard,
    BRow,
    BCol,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    vSelect,
  },
  data() {
    return {
      searchQuery: '',
      pageLength: 10,
      dir: false,
      interviewsResponse: {
        interviews: [],
        count: 1,
      },
      columns: [
        {
          label: '#',
          field: 'index',
          width: '90px',
        },
        {
          label: 'Interviewer Name',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Supplier Name',
          field: 'employer_name',
          sortable: false,
        },
        {
          label: 'Candidate Name',
          field: 'employee_name',
          sortable: false,
        },
        {
          label: 'Consent',
          field: 'consent',
          sortable: false,
        },
        {
          label: 'Interview Date',
          field: 'date',
          width: '120px',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'selectStatus',
          width: '180px',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          width: '120px',
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.query.page
      },
      set(val) {
        this.$store.state.query.page = val
        Interviews.getInterviews(this)
      },
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Started      : 'light-info',
        Completed    : 'light-success',
        Paused       : 'light-primary',
        Cancelled    : 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    '$store.state.lists.hrLists': {
      immediate: true,
      handler() {
        LIST.getInterviewStatusFullList(this)
      },
    },
  },
  created() {
    this.searchQuery = this.$store.state.query.query
    this.interviewsResponse.count = this.$store.state.query.page
    LIST.getInterviewStatusFullList(this)
    Interviews.getInterviews(this)
  },
  methods: {
    confirmDeleteRecord(obj) {
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to delete this ${obj.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          Interviews.delete(this, obj.id)
        }
      })
    },
    onStatusChanged(interview) {
      const updateStatus = this.status.find(status => status.id === interview.status)
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to change this Status to ${updateStatus.label}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Proceed',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const dis = this
          let statusCode = interview.status
          for (let i = 0; i < this.status.length; i += 1) {
            if (this.status[i].name === interview.status) {
              statusCode = this.status[i].id
            }
          }
          Interviews.toggleStatus(dis, interview.id, statusCode)
        }
      })
    },
    updateError(message) {
      this.$swal({
        icon: 'warning',
        title: 'Interview Not Updated!',
        text: message,
      })
    },
    updated(message) {
      Interviews.getInterviews(this)
      this.$swal({
        icon: 'success',
        title: 'Interview Updated!',
        text: message,
      })
    },
    interviewDeleted() {
      Interviews.getInterviews(this)
      this.$swal({
        icon: 'success',
        title: 'Interview Deleted!',
        text: 'Your Interview has been deleted',
      })
    },
    interviewNotDeleted() {
      this.$swal({
        icon: 'warning',
        title: 'Interview Not Deleted!',
        text: 'Your Interview has been not deleted',
      })
    },
    setStatus(status) {
      this.status = status
    },
    updateSearchQuery() {
      this.$store.state.query.query = this.searchQuery
      this.currentPage = 1
    },
    setInterviews(interviewsResponse) {
      this.interviewsResponse = interviewsResponse
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
